import axios from "axios";
import { cropr } from "../adapter";

export const newJWTClient = () => {
  let jwt = "";

  const setJWT = (newJWT) => {
    jwt = newJWT;
  };

  const fetchJWT = async () => {
    let url = "/dss/d2c/jwt/";
    let data = {};
    let options = {
      headers: {
        "X-CSRFToken": cropr?.getCookie ? cropr?.getCookie("csrftoken") : "",
      },
    };

    try {
      const response = await axios.post(url, data, options);
      setJWT(response.data.jwt);
    } catch (e) {
      setJWT("");
    }
  };

  const withJWT = async (requestFunction) => {
    try {
      return await requestFunction(jwt);
    } catch (error) {
      if (error.response?.status === 403) {
        await fetchJWT();
        return await requestFunction(jwt);
      } else {
        throw error;
      }
    }
  };

  return { withJWT, setJWT };
};

export const jwtClient = newJWTClient();
